import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Modal } from 'sa-ui';
import messages from './simulatedCorrectionAuditConfirmModalMessages';

const SimulatedCorrectionAuditConfirmModal = props => (
  <Modal
    show={props.show}
    title={props.intl.formatMessage(messages.title)}
    message={props.intl.formatMessage(messages.message)}
    onClose={props.onClose}
    icon="ti-thumbs-up"
    buttons={[{ onClick: props.onContinue, label: props.intl.formatMessage(messages.continue) }]}
  />
);

SimulatedCorrectionAuditConfirmModal.propTypes = {};

export default injectIntl(SimulatedCorrectionAuditConfirmModal);
